import React, { useEffect } from 'react'

import { GetStaticPropsContext } from 'next'

import { FlexContainer } from '@/components'
import {
  ServiceDetailContainer,
  ProjectsContainer,
  AdaptedProcessesContainer,
} from '@/containers'
import { ServicesHeroContainer } from '@/containers/servicesHero'
import {
  HeroProps,
  AdaptedProcessProps,
  ProjectsContainerProps,
  ServiceDetailsProps,
  getServicePage,
} from '@/service/api/servicesPage'
import { useSmoothScroll } from '@/store/smoothScroll'
import { Constants } from '@/utils/constants'
import { withFooterHeader } from '@/utils/withFooterHeader'
import { withPageStaticProps } from '@/utils/withPageStaticProps'

export type ServicesProps = {
  data: {
    hero: HeroProps
    serviceDetails: ServiceDetailsProps
    adaptedProcess: AdaptedProcessProps
    projectsContainer: ProjectsContainerProps[]
  }
}

const Services: React.FC<ServicesProps> = ({
  data: { hero, serviceDetails, adaptedProcess, projectsContainer },
}) => {
  const { scrollToTop } = useSmoothScroll()
  useEffect(() => {
    scrollToTop()
  }, [scrollToTop])

  return (
    <FlexContainer
      direction="column"
      alignItems="center"
      padding="0"
      style={{
        margin: '112px 0',
        gap: '112px',
        maxWidth: '100%',
      }}
    >
      {hero && <ServicesHeroContainer data={hero} />}
      {serviceDetails && <ServiceDetailContainer data={serviceDetails} />}
      {adaptedProcess && <AdaptedProcessesContainer data={adaptedProcess} />}
      {projectsContainer && <ProjectsContainer data={projectsContainer} />}
    </FlexContainer>
  )
}

export const getStaticProps = withPageStaticProps(
  async (ctx: GetStaticPropsContext) => {
    const { locale } = ctx
    const { hero, serviceDetails, adaptedProcess, projectsContainer } =
      await getServicePage(String(locale))

    return {
      props: {
        data: { hero, serviceDetails, adaptedProcess, projectsContainer },
      },
      revalidate: Constants.ONE_DAY,
    }
  },
)

export default withFooterHeader(Services)
